import React from 'react';

export default function ThinkingIndicator({
  className = '',
  style = undefined,
  text = 'thinking',
}) {
  const classes = ['thinking-indicator', className].filter(Boolean).join(' ');

  return (
    <div className={classes} style={style} role="status" aria-live="polite" aria-label={text}>
      <span className="thinking-ring" aria-hidden="true" />
      <span className="thinking-indicator-text">{text}</span>
    </div>
  );
}
